// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3FoXO","boxTitle":"Qualiphy_boxTitle__3XpDN","box":"Qualiphy_box__1QOYI","toggleWrap":"Qualiphy_toggleWrap__JbXnn"};